import { Tabs, theme, Tooltip } from "antd";
import React from "react";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_USER } from "../../constants/urls";
import { dateTimeToHumanString } from "../../frameworks/Util";
import { 
  EditOutlined,
  PlusCircleOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import UserManageModal from "../../components/user/UserManageModal";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";
import { DELETE } from "../../frameworks/HttpClient";
import ChangePasswordModal from "../../components/user/ChangePasswordModal";

export default function UserManageView() {
  const tableRef = React.useRef(null);
  const [ target, setTarget ] = React.useState(null);
  const [ changePasswordTarget, setChangePasswordTarget] = React.useState(null)
  const [ errorMessages, setErrorMessages] = React.useState(null);
  const {
    token: { colorWarning, colorSuccess, colorError },
  } = theme.useToken();

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const handleDelete = async(id) => {
    setErrorMessages(null)
    try {
      await DELETE(`${URL_USER.USER}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const columns = [
    {
      title: "Action",
      dataIndex: "id",
      width: 170, 
      key: "id",
      render: (_, record) =>
      <center>
        <div onClick={(e) => e.stopPropagation()}>
          <Tooltip triger="hover" title="แก้ไขข้อมูล">
            <ColorButton
              type="primary"
              override={colorWarning}
              style={{ margin: 5 }}
              icon={<EditOutlined />}
              onClick={() => setTarget(record)}
            />
          </Tooltip>
          <CustomDeleteConfirmButton
            tooltips={"ลบผู้ใช้งาน"}
            title={`ลบผู้ใช้งาน - ${record.full_name}`}
            content={"คุณต้องการลบผู้ใช้งานใช่หรือไม่"}
            onOk={ async() => {
              await handleDelete(record.id)
              refreshData();
            }}
            onConfirm={() => refreshData()}
          />
          <Tooltip triger="hover" title="เปลี่ยนรหัสผ่าน">
            <ColorButton
              type="primary"
              override={colorSuccess}
              style={{ margin: 5 }}
              icon={<UnlockOutlined />}
              onClick={() => setChangePasswordTarget(record.id)}
            />
          </Tooltip>
        </div>
      </center>
    },
    {
      title: "Username",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "ชื่อ - นามสกุล",
      dataIndex: "full_name",
      key: "full_name",
    },
    {
      title: "ตำแหน่งงาน",
      dataIndex: "groups",
      key: "groups",
      render: (value) => value && value.join(', ')
    },
    {
      title: "แก้ไขล่าสุด",
      dataIndex: "updated",
      key: "updated",
      render: (value) => dateTimeToHumanString(value)
    },
  ]

  return (
    <div>
      <ColorButton
          type="primary"
          override={colorSuccess}
          style={{ marginBottom: 20, float: 'right' }}
          icon={<PlusCircleOutlined />}
          onClick={() => setTarget('add')}
      >
        เพิ่มผู้ใช้งาน  
      </ColorButton>

      <TSTable
        columns={columns}
        size="small"
        url={`${URL_USER.USER}`}
        ref={tableRef}
      />
      

      <UserManageModal
        open={target ? true : false}
        target={target}
        onClose={() => {
          setTarget(null)
        }}
        onUpdate={() => {
          setTarget(null)
          refreshData();
        }}
      />

      <ChangePasswordModal
        open={changePasswordTarget ? true : false}
        user={changePasswordTarget}
        onClose={() => {
          setChangePasswordTarget(null);
        }}
      />
    </div>
  )
}